// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"c797d878","707":"3424a9dc","729":"34ca6463"}[chunkId] + ".js";
};